// Aplicación espejo: de QUIÉN son las preguntas repetidas.
//
// Lissette, 2026-08-26: *"que salga la pregunta del esposo y, bajo el nombre de
// la esposa, salga la misma pregunta; y si le da a dependientes, también bajo
// el nombre de cada dependiente"*.
//
// Antes las preguntas del cónyuge y de cada dependiente se repetían detrás de
// una línea de puntos, sin decir de quién eran. Quien llena el formulario ve la
// misma pregunta tres veces, no sabe si la página se rompió, y si la contesta
// pensando en sí mismo la respuesta queda archivada bajo otra persona. En un
// formulario de seguros eso no es presentación: es un dato médico atribuido a
// quien no es.
//
// Vive fuera del componente para poder probarlo: la página pública es `.jsx` y
// las pruebas del backend no pueden importarla.

/** Nombre + apellido, sin espacios de más. Cadena vacía si no hay nada. */
const nombreCompleto = (p) => `${(p && p.firstName) || ''} ${(p && p.lastName) || ''}`.trim().replace(/\s+/g, ' ');

/**
 * Cómo llamar en pantalla a la persona del espejo.
 *
 * @param quien  'spouse' o 'dep.<i>' — la misma clave con la que se guardan sus
 *               respuestas en `customValues`.
 * @param form   { spouse, dependents[] } tal cual lo lleva el formulario.
 * @param t      (es, en) => string, el traductor de la página.
 *
 * NUNCA devuelve vacío: mientras no hayan escrito el nombre, se usa el
 * parentesco ("Cónyuge", "Dependiente 2"). Un encabezado en blanco dejaría las
 * preguntas otra vez sin dueño, que es el fallo que esto viene a arreglar.
 * El dependiente se numera desde 1, como lo cuenta quien llena el formulario.
 */
export function nombreDelEspejo(quien, form, t) {
  const tr = typeof t === 'function' ? t : (es) => es;
  if (quien === 'spouse') {
    return nombreCompleto((form || {}).spouse) || tr('Cónyuge', 'Spouse');
  }
  const m = /^dep\.(\d+)$/.exec(String(quien || ''));
  if (!m) return '';
  const i = Number(m[1]);
  const dep = ((form || {}).dependents || [])[i];
  return nombreCompleto(dep) || `${tr('Dependiente', 'Dependent')} ${i + 1}`;
}

/**
 * ¿Tiene el espejo algo que repetir?
 *
 * El interruptor solo repite las notas de salud y las preguntas adicionales.
 * Una plantilla sin ninguna de las dos —una de AUTO recién creada, por
 * ejemplo— lo puede tener encendido y salir exactamente igual que apagado.
 * Ese es el "le doy y no sale" del 2026-08-26: no falla, es que no hay nada
 * que repetir, y hasta hoy no lo decía en ninguna parte.
 */
export function espejoTieneAlgoQueRepetir(sections, customFields) {
  const s = sections || {};
  return !!s.health || (Array.isArray(customFields) && customFields.length > 0);
}
